export default "__VITE_ASSET__CemjZqKC__"